import { render } from "./CompanionAppBundle.vue?vue&type=template&id=93aee1a8&scoped=true"
import script from "./CompanionAppBundle.vue?vue&type=script&lang=js"
export * from "./CompanionAppBundle.vue?vue&type=script&lang=js"

import "./CompanionAppBundle.vue?vue&type=style&index=0&id=93aee1a8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93aee1a8"]])

export default __exports__